var LifeCycleEventName = /* @__PURE__ */ ((LifeCycleEventName2) => {
  LifeCycleEventName2["beforeFetchUserInfo"] = "beforeFetchUserInfo";
  LifeCycleEventName2["afterFetchUserInfo"] = "afterFetchUserInfo";
  LifeCycleEventName2["beforeFetchConsentData"] = "beforeFetchConsentData";
  LifeCycleEventName2["afterFetchConsentData"] = "afterFetchConsentData";
  LifeCycleEventName2["beforeFetchNotificationData"] = "beforeFetchNotificationData";
  LifeCycleEventName2["afterFetchNotificationData"] = "afterFetchNotificationData";
  LifeCycleEventName2["beforeUpdateRecords"] = "beforeUpdateRecords";
  LifeCycleEventName2["afterUpdateRecords"] = "afterUpdateRecords";
  LifeCycleEventName2["beforeNotify"] = "beforeNotify";
  LifeCycleEventName2["afterNotify"] = "afterNotify";
  LifeCycleEventName2["beforeRemoveNotification"] = "beforeRemoveNotification";
  LifeCycleEventName2["afterRemoveNotification"] = "afterRemoveNotification";
  LifeCycleEventName2["beforeThirdPartyApprove"] = "beforeThirdPartyApprove";
  LifeCycleEventName2["afterThirdPartyApprove"] = "afterThirdPartyApprove";
  LifeCycleEventName2["beforeThirdPartyReject"] = "beforeThirdPartyReject";
  LifeCycleEventName2["afterThirdPartyReject"] = "afterThirdPartyReject";
  return LifeCycleEventName2;
})(LifeCycleEventName || {});
var StorageType = /* @__PURE__ */ ((StorageType2) => {
  StorageType2["sessionStorage"] = "sessionStorage";
  StorageType2["localStorage"] = "localStorage";
  StorageType2["inMem"] = "inMem";
  return StorageType2;
})(StorageType || {});
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["INFO"] = "info";
  LogLevel2["WARN"] = "warn";
  LogLevel2["ERROR"] = "error";
  return LogLevel2;
})(LogLevel || {});
var EntityRelation = /* @__PURE__ */ ((EntityRelation2) => {
  EntityRelation2["AND"] = "AND";
  EntityRelation2["OR"] = "OR";
  return EntityRelation2;
})(EntityRelation || {});
var ConsentEntityCategory = /* @__PURE__ */ ((ConsentEntityCategory2) => {
  ConsentEntityCategory2["CONDITIONS"] = "Conditions";
  ConsentEntityCategory2["DATA"] = "Data";
  ConsentEntityCategory2["PERMISSION"] = "Permissions";
  return ConsentEntityCategory2;
})(ConsentEntityCategory || {});
var ConsentStatus = /* @__PURE__ */ ((ConsentStatus2) => {
  ConsentStatus2["UNSUPPORTED"] = "Unsupported";
  ConsentStatus2["APPROVE"] = "Approve";
  ConsentStatus2["REJECT"] = "Reject";
  return ConsentStatus2;
})(ConsentStatus || {});
const ConsentStatusParam = {
  ["Unsupported" /* UNSUPPORTED */]: 0,
  ["Approve" /* APPROVE */]: 1,
  ["Reject" /* REJECT */]: 2
};
var ConsentRecordType = /* @__PURE__ */ ((ConsentRecordType2) => {
  ConsentRecordType2[ConsentRecordType2["CONSENT_RECORD_TYPE_UNSUPPORTED"] = 0] = "CONSENT_RECORD_TYPE_UNSUPPORTED";
  ConsentRecordType2[ConsentRecordType2["CONSENT_RECORD_TYPE_USER"] = 1] = "CONSENT_RECORD_TYPE_USER";
  ConsentRecordType2[ConsentRecordType2["CONSENT_RECORD_TYPE_DEVICE"] = 2] = "CONSENT_RECORD_TYPE_DEVICE";
  return ConsentRecordType2;
})(ConsentRecordType || {});
var ConsentEntityValidator = /* @__PURE__ */ ((ConsentEntityValidator2) => {
  ConsentEntityValidator2["DEVICE_ID"] = "DeviceID";
  ConsentEntityValidator2["USER_ID"] = "UserID";
  ConsentEntityValidator2["ANY"] = "Any";
  ConsentEntityValidator2["BOTH"] = "Both";
  return ConsentEntityValidator2;
})(ConsentEntityValidator || {});
var StorageName = /* @__PURE__ */ ((StorageName2) => {
  StorageName2["DEVICE_CONSENT"] = "device";
  StorageName2["USER_CONSENT"] = "user";
  StorageName2["BOTH_CONSENT"] = "both";
  StorageName2["NOTIFICATION"] = "notification";
  return StorageName2;
})(StorageName || {});
var ApiVersion = /* @__PURE__ */ ((ApiVersion2) => {
  ApiVersion2["V1"] = "v1";
  ApiVersion2["V2"] = "v2";
  return ApiVersion2;
})(ApiVersion || {});
export {
  ApiVersion,
  ConsentEntityCategory,
  ConsentEntityValidator,
  ConsentRecordType,
  ConsentStatus,
  ConsentStatusParam,
  EntityRelation,
  LifeCycleEventName,
  LogLevel,
  StorageName,
  StorageType
};
